import { Component } from '@angular/core';
import { MatDialogRef } from '@angular/material';

@Component({
    selector: 'dialog-manage-pukal-loading',
    templateUrl: 'dialog.loading.html',
})
export class ManagePukalLoadingDialog {
    constructor(public dialogRef: MatDialogRef<ManagePukalLoadingDialog>) { }
}